<script setup>
  import { computed } from "vue";
  import { useChartPreview } from "../composables/useChartPreview";

  const props = defineProps({
    colors: { type: Array, required: true },
    width: { type: Number, required: true },
    height: { type: Number, required: true },
    padding: { type: Number, required: true },
    seriesCount: { type: Number, required: true },
    categoryCount: { type: Number, required: true },
  });

  const { chartWidth, chartHeight, displayColors, getValue } = useChartPreview(props);

  const clusteredGroupGap = 8;

  const categoryColumnSpacing = computed(() => {
    const totalGaps = (props.categoryCount - 1) * clusteredGroupGap;
    return (chartWidth.value - totalGaps) / props.categoryCount + clusteredGroupGap;
  });

  const clusteredColWidth = computed(() => {
    const groupWidth = categoryColumnSpacing.value - clusteredGroupGap;
    return Math.max(4, groupWidth / props.seriesCount);
  });

  function getColHeight(catIdx, seriesIdx) {
    return chartHeight.value * getValue(catIdx, seriesIdx);
  }
</script>

<template>
  <g
    v-for="(cat, catIdx) in categoryCount"
    :key="catIdx">
    <rect
      v-for="(series, seriesIdx) in seriesCount"
      :key="seriesIdx"
      :x="padding + catIdx * categoryColumnSpacing + seriesIdx * clusteredColWidth"
      :y="height - padding - getColHeight(catIdx, seriesIdx)"
      :width="clusteredColWidth - 1"
      :height="getColHeight(catIdx, seriesIdx)"
      :fill="displayColors[seriesIdx % displayColors.length]"
      rx="1" />
  </g>
</template>
